import { computedInternalUrl, imageProjection, internalReferenceUrl, LOGO_PROJECTTION } from './projection';

export const internalReference = (field = 'internalReference') => `
  ${field}->{
    _id,
    _type,
    name,
    "url": ${computedInternalUrl}
  }
`;

export const HEADER_MEGA_MENU_QUERY = `
  *[_type == "header"][0] {
    "headerLogo": ${LOGO_PROJECTTION},
    "navigationItems": megaMenuNavigationItems[] {
      _type == "navigationItemLevel1" => {
        ...,
        "navigationType": "level1",
        "label": title,
        link{
          ...,
          ${internalReference()}
        },
        advertisingBanner {
          ...,
          "image": image { ${imageProjection} },
          isEnabled,
          "label": text,
          link{
            "type": link.type,
            "href": ${internalReferenceUrl},
            "isOpenInNewTab": coalesce(link.isOpenInNewTab, link.newTab)
          }
        },

        "childrenColumn": select(
          layoutType == "column" => childrenColumn[] {
            ...,
            "navigationType": "level2Column",
            "label": title,
            link{
              ...,
              ${internalReference()}
            },
            "childrenColumn": children[] {
              _type == "navigationItemLevel3" => {
                ...,
                "navigationType": "level3",
                "label": title,
                link{
                  ...,
                  ${internalReference()}
                },
              }
            }
          }
        ),

        "childrenGrid": select(
          layoutType == "grid" => childrenGrid[] {
            ...,
            "navigationType": "level2Grid",
            ${internalReference('link')},
            "label": title,
            description,
            "thumbnail": thumbnail { ${imageProjection} },
          }
        )
      }
    },
    "primaryButton": primaryButton{
      ...,
      link{
        ...,
        "url": ${internalReferenceUrl},
      }
    }
  }
`;
